import AsyncStorage from "@react-native-async-storage/async-storage";
import { useNavigation } from "@react-navigation/core";
import React, { useEffect, useState } from "react";
import { Text, View } from "react-native";
import { ScrollView, TouchableOpacity } from "react-native-gesture-handler";
import Button from "../../components/Button";
import api from "../../services/api";
import balanceService from "../../services/balanceService";
import clientService from "../../services/clientService";
import feeService from "../../services/feeService";
import { formatCoin, formatGPXBalance } from "../../utils/formatNumber";
import toast from "../../utils/toast";
import styles from "./styles";
import HeaderTabs from "../../components/HeaderTabs";
import { FormattedMessage, useIntl } from "react-intl";
import GoBackButton from "../../components/GoBackButton";
import { If, Then, Else } from "react-if";

/*
 * ROUTE PARAMS -> qtd (float), token (actives.activeId), viewType(buy|sell), market (optional:true|false,default:false)
 */

const ConfirmTransfer = (props) => {
  const [uri, setUri] = useState("");
  const [nameToken, setNameToken] = useState("GPX");
  const [valueToken, setValueToken] = useState(1);

  const [qtd, setQtd] = useState(1);

  const [activeIdTokenId, setActiveIdTokenId] = useState();
  const [activeIdTokenObj, setActiveIdTokenObj] = useState();
  const [balance, setBalance] = useState(0); // Active/Token Balance
  const [balanceGPX, setBalanceGPX] = useState(0); // GPX Balance
  const [authToken, setAuthToken] = useState();
  const [taxes, setTaxes] = useState(0.1);
  const [fee, setFee] = useState({
    fee: 0.1,
    type: "fixed",
  });

  const [findUserBy, setFindUserBy] = useState("");
  const [userKey, setUserKey] = useState("");
  const [toUser, setToUser] = useState();

  //TODO: Carregar taxas.

  const navigation = useNavigation();
  const intl = useIntl();

  useEffect(() => {
    loadTokenAndRequest();
  }, []);

  useEffect(() => {
    if (props.route.params.qtd)
      // amount to transfer
      setQtd(props.route.params.qtd);
    else setQtd(1);
    if (props.route.params.token)
      // token/active to transfer
      setActiveIdTokenId(props.route.params.token);
    if (props.route.params.findUserBy)
      setFindUserBy(props.route.params.findUserBy);
    if (props.route.params.userKey) setUserKey(props.route.params.userKey);
  }, []);

  useEffect(() => {
    getDataCoin();
    loadBalance();
  }, [activeIdTokenId]);

  useEffect(() => {
    if (authToken) {
      loadBalance();
      loadFees();
    }
  }, [authToken]);

  useEffect(() => {
    if (authToken && findUserBy.length > 0 && userKey.length > 0) {
      clientService
        .findClientByEmailOrDocument(authToken, findUserBy, userKey)
        .then((response) => {
          console.log(response.data);
          if (response.status === 500 || !response.data?.find) {
            toast(
              intl.formatMessage({
                id: "confirmTransfer.erroUserNaoEncontrado",
              }),
              "#DA1414"
            );
            navigation.goBack();
          } else {
            setToUser(response.data.result);
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 500) {
            toast(
              intl.formatMessage({
                id: "confirmTransfer.erroUserNaoEncontrado",
              }),
              "#DA1414"
            );
            navigation.goBack();
          } else {
            console.log("Error:", error.message);
          }
        });
    }
  }, [authToken, findUserBy, userKey]);

  const loadTokenAndRequest = async () => {
    const authTokenStorage = await AsyncStorage.getItem("JWT_TOKEN");
    setAuthToken(authTokenStorage);
  };

  const loadBalance = () => {
    if (authToken) {
      if (parseInt(activeIdTokenId + "") !== -1) {
        balanceService
          .getBalanceOfToken(authToken, activeIdTokenId)
          .then((response) => {
            setBalance(response?.data?.saldo + "");
          })
          .catch((error) => {});
      }
      balanceService
        .getBalanceOfGpx(authToken)
        .then((res) => {
          if (res?.data?.balance?.length > 0) {
            let balanceReturn = 0;
            if (res.data.balance[0]?.available_balance) {
              balanceReturn = res.data.balance[0].available_balance;
            } else {
              balanceReturn = res.data.balance[0].saldo;
            }
            setBalanceGPX(balanceReturn);
            if (parseInt(activeIdTokenId + "") === -1) {
              setBalance(balanceReturn);
            }
          }
        })
        .catch((error) => {});
    }
  };

  const getDataCoin = async () => {
    const token = await AsyncStorage.getItem("JWT_TOKEN");
    if (activeIdTokenId && parseInt(activeIdTokenId + "") !== -1) {
      api
        .get(`/actives/${activeIdTokenId}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          if (res.data.actives.length > 0) {
            //    console.log(res.data.actives);
            setActiveIdTokenObj(res.data.actives[0]);
            setNameToken(res.data.actives[0].name_token);
            setUri(
              `https://filesgpx.s3.us-east-2.amazonaws.com/${res.data.actives[0].path}`
            );
            setValueToken(res.data.actives[0].single_value); //TODO: Implementar valores fixos e flutuantes -> BUG
            // res.data.actives[0].type_value == "Valor Fixo" ?
            //     setValueToken(res.data.actives[0].single_value)
            // :   setValueToken(res.data.actives[0].total_value_token)
          }
        })
        .catch((error) => {
          //console.log(error);
        });
    } else {
      setActiveIdTokenObj({
        id: -1,
        name_token: "GPX/BRL",
        single_value: 1,
        amount_token: "=",
        cryptoactive: false,
      });
      setNameToken("GPX/BRL");
      setUri("");
      setValueToken(1);
    }
  };

  const loadFees = () => {
    if (authToken) {
      if (parseInt(activeIdTokenId + "") !== -1) {
        feeService
          .getTransferOutFeeByActiveId(authToken, activeIdTokenId)
          .then((response) => {
            if (response.status === 200) {
              setFee(response.data);
            } else {
              console.log("unable to load fee");
            }
          })
          .catch((error) => {
            console.log("unable to load fee");
          });
      } else {
        setFee({ fee: 0.0099, type: "factor" });
      }
    }
  };

  const getCurrentFee = () => {
    if (activeIdTokenObj?.cryptoactive && fee.type) {
      return fee.type === "fixed"
        ? parseFloat(fee.fee)
        : parseFloat(fee.fee) * parseFloat(qtd);
    } else if (fee.type) {
      return fee.type === "fixed"
        ? fee.fee
        : parseFloat(fee.fee) * parseFloat(qtd) * parseFloat(valueToken); // descontado no recebimento
    }
  };

  const getTotalReceive = () => {
    let currentFee = getCurrentFee();
    if (activeIdTokenObj?.cryptoactive && fee.type) {
      return qtd - currentFee;
    } else if (fee.type) {
      return qtd;
    }
  };

  const getBalanceToken = () => {
    return balance - qtd;
  };

  const getBalanceGPX = () => {
    let currentFee = getCurrentFee();
    if (activeIdTokenObj?.cryptoactive && fee.type) {
      return balanceGPX;
    } else if (fee.type) {
      return balanceGPX - currentFee;
    }
  };

  return (
    <>
      <HeaderTabs
        title={<FormattedMessage id="transfer.tituloTransferir" />}
        subtitle={<FormattedMessage id="transfer.desejoTransferir" />}
      />

      <ScrollView>
        <View style={styles.container}>
          <Text style={styles.title}>
            <FormattedMessage id="confirmTransfer.txtConfimaTransferencia" />
          </Text>

          <View style={styles.contentPrice}>
            <Text style={{ textAlign: "center" }}>
              <FormattedMessage id="confirmTransfer.txtConfirmTransferencia" />
            </Text>
          </View>

          <View style={styles.confirmDataRow}>
            <Text style={styles.text}>
              <FormattedMessage id="confirmTransfer.txtRecebedor" />
            </Text>

            <Text style={[styles.text, styles.bold]}>
              {toUser?.first_name} {toUser?.last_name}
            </Text>
          </View>

          <View style={styles.hrLine}></View>

          <View style={styles.confirmDataRow}>
            <Text style={styles.text}>
              <FormattedMessage id="confirmTransfer.txtEmailCpfCnpj" />
            </Text>
            <Text style={[styles.text, styles.bold]}>{userKey}</Text>
          </View>

          <View style={styles.hrLine}></View>

          <If condition={activeIdTokenObj?.cryptoactive}>
            <Then>
              <View style={styles.confirmDataRow}>
                <Text style={styles.text}>
                  <FormattedMessage id="confirmTransfer.txtTaxa" />
                </Text>
                <Text style={[styles.text, styles.bold]}>
                  {getCurrentFee()} {activeIdTokenObj?.name_token}
                </Text>
              </View>
            </Then>
          </If>
          <View style={styles.confirmDataRow}>
            <Text style={styles.text}>
              <FormattedMessage id="confirmTransfer.txtTotalReceber" />
            </Text>
            <Text style={[styles.text, styles.bold]}>
              {getTotalReceive()} {activeIdTokenObj?.name_token}
            </Text>
          </View>

          <View style={styles.hrLine}></View>

          <If
            condition={activeIdTokenId && parseInt(activeIdTokenId + "") === -1}
          >
            <Then>
              <>
                <View style={styles.confirmDataRow}>
                  <Text style={styles.text}>
                    <FormattedMessage id="confirmTransfer.txtSaldoGpxBrl" />
                  </Text>
                  <Text style={[styles.text, styles.bold]}>
                    {formatGPXBalance(balanceGPX)}
                    <FormattedMessage id="confirmTransfer.txtGpxBrl" />
                  </Text>
                </View>

                <View style={styles.hrLine}></View>

                <View style={styles.confirmDataRow}>
                  <Text style={styles.text}>
                    <FormattedMessage id="confirmTransfer.txtTaxa" />
                  </Text>
                  <Text style={[styles.text, styles.bold]}>
                    {formatGPXBalance(getCurrentFee())}
                    <FormattedMessage id="confirmTransfer.txtGpxBrl" />
                  </Text>
                </View>

                <View style={styles.hrLine}></View>

                <View style={styles.confirmDataRow}>
                  <Text style={styles.text}>
                    <FormattedMessage id="confirmTransfer.txtSaldoGpxBrlPosTransferencia" />
                  </Text>
                  <Text style={[styles.text, styles.bold]}>
                    {formatGPXBalance(getBalanceToken() - getCurrentFee())}
                    <FormattedMessage id="confirmTransfer.txtGpxBrl" />
                  </Text>
                </View>

                <View style={styles.hrLine}></View>
              </>
            </Then>
            <Else>
              <>
                <View style={styles.confirmDataRow}>
                  <Text style={styles.text}>
                    <FormattedMessage id="confirmTransfer.txtSaldo" />
                  </Text>
                  <Text style={[styles.text, styles.bold]}>
                    {balance} {activeIdTokenObj?.name_token}
                  </Text>
                </View>

                <View style={styles.hrLine}></View>

                <View style={styles.confirmDataRow}>
                  <Text style={styles.text}>
                    <FormattedMessage id="confirmTransfer.txtSaldoPostTransferencia" />
                  </Text>
                  <Text style={[styles.text, styles.bold]}>
                    {getBalanceToken()} {activeIdTokenObj?.name_token}
                  </Text>
                </View>

                <View style={styles.hrLine}></View>

                <View style={styles.confirmDataRow}>
                  <Text style={styles.text}>
                    <FormattedMessage id="confirmTransfer.txtSaldoGpxBrl" />
                  </Text>
                  <Text style={[styles.text, styles.bold]}>
                    {formatGPXBalance(balanceGPX)}
                    <FormattedMessage id="confirmTransfer.txtGpxBrl" />
                  </Text>
                </View>

                <View style={styles.hrLine}></View>
                {!activeIdTokenObj?.cryptoactive && (
                  <View style={styles.confirmDataRow}>
                    <Text style={styles.text}>
                      <FormattedMessage id="confirmTransfer.txtTaxa" />
                    </Text>
                    <Text style={[styles.text, styles.bold]}>
                      {formatCoin(
                        getCurrentFee(),
                        activeIdTokenObj?.feezeroMk || 2
                      )}{" "}
                      {activeIdTokenObj?.name_token}
                    </Text>
                  </View>
                )}

                <View style={styles.hrLine}></View>

                <View style={styles.confirmDataRow}>
                  <Text style={styles.text}>
                    <FormattedMessage id="confirmTransfer.txtSaldoGpxBrlPosTransferencia" />
                  </Text>
                  <Text style={[styles.text, styles.bold]}>
                    {formatGPXBalance(getBalanceGPX())}
                    <FormattedMessage id="confirmTransfer.txtGpxBrl" />
                  </Text>
                </View>
                <View style={styles.hrLine}></View>
              </>
            </Else>
          </If>
          {parseFloat(balance) < qtd ? (
            <Button
              route={"DepositMethod"}
              text={
                <FormattedMessage id="confirmTransfer.msgSaldoInsuficiente" />
              }
              props={{}}
            />
          ) : (
            <View style={styles.contentBtn}>
              <TouchableOpacity
                style={styles.btn}
                onPress={() =>
                  props.navigation.navigate({
                    name: "ConfirmPasswordTransfer",
                    params: {
                      qtd: qtd,
                      token: activeIdTokenId,
                      userId: toUser?.user_id,
                    },
                  })
                }
              >
                <Text style={styles.textBtn}>
                  <FormattedMessage id="confirmTransfer.btnConfirmar" />
                </Text>
              </TouchableOpacity>
            </View>
          )}
          <GoBackButton />
        </View>
      </ScrollView>
    </>
  );
};

export default ConfirmTransfer;
